BX.Vue.component('aos__popup',
    {
        computed: {},
        data: function () {
            return {
                id: null,
                data: null
            };
        },
        methods: {
            isData: function () {
                return typeof this.data === 'object' && this.data.length > 0;
            }
        },
        mounted: function () {
            let vm = this;
            vm.id = vm.$attrs.id;
            vm.data = vm.$attrs.data ? vm.$attrs.data : vm.data;
        },
        template: `
          <div class="aos__popup">
          <div v-if="isData" class="popup-window popup-window-agreement popup-open-account" :data-id="this.id"
               :id="this.id + '-content'" style="display:none;">
            <div class="popup-content __scroll">
              <label class="l_checkbox" v-for="(item, index) in data" :key="index"
                     :style="index === 0 && {pointerEvents: 'none'}">
                <input type="checkbox" name="form_checkbox_AGREE_LIST[]" :value="item.id"
                       :required="index === 0" :checked="true" :disabled="index === 0"
                       :style="index === 0 && {opacity: 0.6}"/>
                <div v-html="item.text"></div>
              </label>
            </div>
            <a href="#" class="close-popup"></a>
          </div>
          </div>
        `,
    }
);